// What AppShell knows about the screen size ({ bp, mobile, tablet, desktop,
// pad }), for screens rendered inside it: Tables pass stacked={mobile}, stat
// rows narrow to 140px tiles on phones.
import { createContext, useContext } from 'react';

const DESKTOP = { bp: 'desktop', mobile: false, tablet: false, desktop: true, pad: 32 };

export const ShellLayoutContext = createContext(DESKTOP);

export function useShellLayout() {
  return useContext(ShellLayoutContext);
}
